module.exports = __webpack_public_path__ + "img/circle2Green.ac5a4ad3.svg";